/* Carter · i numeri salgono quando la sezione entra davvero in vista.

   Prima partivano da soli dopo tre secondi, ovunque fossi nella pagina:
   arrivando lì l'effetto era già finito. Adesso l'innesco è uno solo,
   legato alla posizione della sezione, e vale anche quando lo scorrimento
   avviene dentro un contenitore del tema.
*/
(function(){

  var DURATA = 1100;   /* millisecondi */

  function pezzi(testo){
    var m = String(testo).match(/^(\D*?)(\d[\d.,]*)(.*)$/);
    if (!m) return null;
    return { prima:m[1], cifra:m[2], dopo:m[3] };
  }

  function corri(el){
    if (el.dataset.run) return;
    var p = pezzi(el.textContent);
    if (!p) { el.dataset.run = '1'; return; }
    el.dataset.run = '1';

    var decimali = (p.cifra.split(/[.,]/)[1] || '').length;
    var sep = p.cifra.indexOf(',') > -1 ? ',' : '.';
    var meta = parseFloat(p.cifra.replace(',', '.'));
    if (!isFinite(meta)) return;

    function scrivi(v){
      var s = v.toFixed(decimali);
      if (sep === ',') s = s.replace('.', ',');
      el.innerHTML = p.prima + '<span class="num-run">' + s + '</span>' + p.dopo;
    }

    var t0 = null;
    function passo(t){
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / DURATA);
      var e = 1 - Math.pow(1 - k, 3);          /* frenata dolce alla fine */
      scrivi(meta * e);
      if (k < 1) requestAnimationFrame(passo);
      else el.textContent = p.prima + p.cifra + p.dopo;
    }

    scrivi(0);
    requestAnimationFrame(passo);
  }

  function avvia(sez){
    if (sez.dataset.carterNum) return;
    sez.dataset.carterNum = '1';

    var cifre = sez.querySelectorAll('b');
    var ridotto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var partito = false;
    function via(){
      if (partito) return;
      partito = true;
      sez.classList.add('is-in');
      if (ridotto) return;
      cifre.forEach(function(el, i){ setTimeout(function(){ corri(el); }, i * 110); });
    }

    /* la sezione è entrata per almeno un terzo dal basso? */
    function guarda(){
      var r = sez.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < h * 0.82 && r.bottom > h * 0.12) {
        via();
        document.removeEventListener('scroll', guarda, true);
        window.removeEventListener('resize', guarda);
      }
    }

    document.addEventListener('scroll', guarda, true);
    window.addEventListener('resize', guarda);
    guarda();
  }

  function init(){ document.querySelectorAll('.carter-numbers').forEach(avvia); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
